module.exports = __webpack_public_path__ + "img/bookmark.9fa98030.svg";